"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Event_1 = __importDefault(require("../Event"));
const index_1 = require("../index");
/**
 * @name StreamUpdated
 * Internal Event
 */
class StreamUpdated extends Event_1.default {
    constructor() {
        super(index_1.EventType.StreamUpdated);
    }
    static fromData(data) {
        const event = new StreamUpdated();
        event.peerId = data === null || data === void 0 ? void 0 : data.peerId;
        event.stream = data === null || data === void 0 ? void 0 : data.stream;
        return event;
    }
}
exports.default = StreamUpdated;
